import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import { getProfile, getSummary, updateProfile } from "./queries";
import { setAuth } from "./adminSlice";

const adminApi = createApi({
  reducerPath: "admin",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    //get admin summary
    getSummary: builder.query({
      query: getSummary,
    }),

    //get admin profile
    getProfile: builder.query({
      query: getProfile,
      providesTags: ["profile"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (res.data) {
            console.log(res.data);
            // localStorage.setItem("user", JSON.stringify(res.data.user));
            // localStorage.setItem("token", JSON.stringify(res.data.token));
            dispatch(setAuth(res.data));
          }
        } catch (err) {
          console.log(err?.error?.data?.error?.message);
        }
      },
    }),

    //update admin profile
    updateProfile: builder.mutation({
      query: updateProfile,
      invalidatesTags: ["profile"],
    }),
  }),
});

export const {
  useGetSummaryQuery,
  useGetProfileQuery,
  useUpdateProfileMutation,
  reducer: adminReducer,
  reducerPath: adminReducerPath,
  middleware: adminMiddleware,
  endpoints: adminEndpoints,
} = adminApi;
